import { render } from "./McpToolPermissionsManagement.vue?vue&type=template&id=df14809c&scoped=true"
import script from "./McpToolPermissionsManagement.vue?vue&type=script&lang=js"
export * from "./McpToolPermissionsManagement.vue?vue&type=script&lang=js"

import "./McpToolPermissionsManagement.vue?vue&type=style&index=0&id=df14809c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df14809c"]])

export default __exports__